export class AssertionException extends Error {
  constructor(details: string) {
    super(`AssertionException, details: ${details}`);

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, AssertionException.prototype);
  }
}
